import { isNonProductionOrigin } from "../utils"

export const EDUCATION_PERSONA_STORAGE_KEY = "account:educationPersona"

const getStorage = () =>
  typeof window !== "undefined" ? window.sessionStorage : null

export const isEducationPersonaSwitcherEnabled = () => isNonProductionOrigin()

export const readEducationPersonaKey = () => {
  const storage = getStorage()

  if (!storage || !isEducationPersonaSwitcherEnabled()) {
    return null
  }

  return storage.getItem(EDUCATION_PERSONA_STORAGE_KEY)
}

export const writeEducationPersonaKey = key => {
  const storage = getStorage()

  if (storage) {
    storage.setItem(EDUCATION_PERSONA_STORAGE_KEY, key)
  }
}

export const clearEducationPersonaKey = () => {
  const storage = getStorage()

  if (storage) {
    storage.removeItem(EDUCATION_PERSONA_STORAGE_KEY)
  }
}
